import { FunctionComponent, useContext, useEffect, useState } from "react";
import styles from "./ProfileDetails.module.css";
import images from '../../assets/images/index'
import MyAccountTop from "../../components/shared-components/profile/MyAccountTop";
import { globalContext } from "../../Provider/AppProvider";
import EmailInputField from "../../components/shared-components/input-field/EmailInputField";
import { useForm } from "react-hook-form";
import { Button, CircularProgress, styled } from "@mui/material";
import { CustomTextField, InputPropsForAddAffiliates, getFormattedDate, roles, resolvePreferredPortalRole } from "../../helper";
import CloseIcon from '@mui/icons-material/Close';
import  ToasterWithMessage from '../../components/shared-components/toaster'
import moment from "moment";
import { useLazyQuery, useMutation } from "@apollo/client";
import { PRE_SIGNED_URL, UPLOAD_PROFILE } from "./api/ProfileQuery";
import axios from "axios";
import { GET_USER_PROFILE } from "../Auth/api/SignInQuery";
import { GET_NOTIFICATIONS } from "../../components/shared-components/notification/api/NotificationQuery";


const CustomizeButton = styled(Button)(()=>({
  height: '44px',
  width: '138px',
  borderRadius: 0,
  fontSize: 'var(--sub-s-h2-16-semibold-center-size)',
  fontFamily: 'var(--body-b3-12-semibold-left)',
  color: '#151A34',
  backgroundColor: '#F3F4F6',
  border: '1px solid #E3E5E8',
  '&.MuiButton-root':{
     textTransform: "capitalize",
     fontWeight: "bold",
  }
 }))

 const InputField = CustomTextField();

interface InputDataProps{
  email: string,
  fullname: string,
  phonenumber: string,
  photo : string
}

interface SubmitData {
  fullname: string,
  phonenumber: string,
  email: string,
  photo: string
}
const ProfileDetails: FunctionComponent = () => {
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('errorTabIndex');
  localStorage.removeItem('settingsTabIndex');
  const {error,success} = ToasterWithMessage();
  const {personDoodle,DefaultProfile} = images;
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [isEdit,setIsEdit] = useState<boolean>(false);
  const [fileName, setFileName] = useState(null);
  const [file, setFile] = useState(null);
  const [photo,setPhoto] = useState("");
  const baseURL = process.env.REACT_APP_FRONTEND_URL;
  const bucketName = process.env.REACT_APP_BUCKET_NAME;
  const [inputData,setInputData] = useState<InputDataProps>();
  const [disable,setDisable] = useState<boolean>(true);
  const {register,handleSubmit,reset,trigger,setValue,watch,formState: {errors}} = useForm(
  {defaultValues: {
     fullname: '',
     phonenumber: '',
     email: '',
     photo: ''
  },
  mode: "onTouched"});
  const [uploadAdminProfile] = useMutation(UPLOAD_PROFILE, {
    fetchPolicy: 'no-cache',
    onCompleted: (responseData)=> {
        const tempState = { ...globalState};
        tempState.profile.profileUpdate = true;
        handleGlobalState(tempState);
        success("Updated successfully");
    },
    onError: (err) => {
        setDisable(true);
        error(err.message);
    }
  })
  const [getUserProfile,{loading: profileLoading}] = useLazyQuery(GET_USER_PROFILE, {
    fetchPolicy: "no-cache",
    onCompleted: (userdata) => {
      const adminFirstName = userdata?.get_user_profile[0]?.u_first_name;
      const adminLastName = userdata?.get_user_profile[0]?.u_last_name;
      const adminMailId =userdata?.get_user_profile[0]?.u_email_id;
      const adminAvatar = userdata?.get_user_profile[0]?.u_avatar_url;
      const adminPhoneNumber = userdata?.get_user_profile[0]?.u_phone_number;
      const adminUserId = userdata?.get_user_profile[0]?.u_id;
      const adminUserRole = userdata?.get_user_profile[0]?.u_role;
      const allowedRoles = userdata?.get_user_profile?.[0]?.u_allowed_roles || [];
      const storedRole = localStorage.getItem("x-hasura-user-role") || "";
      const preferredRole = resolvePreferredPortalRole(allowedRoles, adminUserRole);
      const tempData = {...globalState}
      tempData.profile.id = adminUserId? adminUserId:"";
      tempData.profile.firstName = adminFirstName ? adminFirstName : tempData?.profile?.firstName
      tempData.profile.lastName =(adminLastName && adminLastName.trim() !== '')? adminLastName: adminLastName === ''? '': tempData?.profile?.lastName ;
      tempData.profile.mailId = adminMailId ? adminMailId : tempData?.profile?.mailId
      tempData.profile.photo = adminAvatar ? adminAvatar : tempData?.profile?.photo
      tempData.profile.phonenumber = adminPhoneNumber ? adminPhoneNumber : tempData?.profile?.phonenumber
      tempData.profile.profileUpdate = false;
      tempData.profile.userRole =
        preferredRole ||
        (storedRole && (allowedRoles.includes(storedRole) || storedRole === adminUserRole) ? storedRole : "") ||
        (adminUserRole ? adminUserRole : tempData.profile.userRole)
      localStorage.setItem("x-hasura-user-role", tempData.profile.userRole);
      handleGlobalState({...tempData,tempData});
    },
    onError: ()=>{
        error("Something went wrong!");
    }
  });
  const [getSignerUrlForUpload] = useLazyQuery(PRE_SIGNED_URL,{
    onCompleted: async  (data) => {
      const res = data?.getUploadSignedUrl?.preSignedUrl
      const url = res.split('?')[0];
      const finalUrl = url.split(`.com/`)[1];

      const response = await axios.put(res,fileName,{
        headers: {
          'Content-Type': 'application/octet-stream'}});
          
          if(response.status === 200){
            const fullName = inputData?.fullname || '';
            const words = fullName.split(' ');
            const lastname = words.length > 1 ? words.pop():"" ;
            const firstname = words.join(' ')
             await uploadAdminProfile({
              variables: {
                "emailId" : globalState?.profile?.mailId ? globalState?.profile?.mailId : "",
                "input": {
                  "u_first_name": firstname,
                  "u_last_name": lastname,
                  "u_phone_number": inputData?.phonenumber,
                  "u_avatar_url": finalUrl
                }
              }
             })
          }
    }
  })

  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempData = {...globalState}
      tempData.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempData.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempData)
    }
  })

  useEffect(()=>{
    const date = getFormattedDate(new Date());
    const temprecord = {...globalState}
    if(globalState.notification.notificationClicked){
      temprecord.notification.notificationClicked = false;
      temprecord.notification.tp_id_array=null;
      temprecord.globalSearch.searchtext = "";
      temprecord.notification.text = "";
      temprecord.notification.ticketId =null;
      temprecord.notification.tpId = null;
      handleGlobalState(temprecord)
    }else if(globalState.error.errorClicked){
      temprecord.error.errorClicked = false;
      temprecord.globalSearch.searchtext = "";
      temprecord.error.text = "";
      temprecord.error.approximateTpArray = null
      temprecord.error.ticketPlacementId = null
      temprecord.error.status = ""
      handleGlobalState(temprecord)
    }else if(globalState.soldTickets.failed){
      temprecord.soldTickets.failed = false
      temprecord.globalSearch.searchtext = "";
      temprecord.soldTickets.emailId = "";
      handleGlobalState(temprecord)
    }
    getWebNotification({
      variables:{
        todayDate: date,
        userId: globalState?.profile?.id
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  useEffect(() => {
      setValue('email',globalState.profile.mailId);
      if(globalState.profile.firstName && globalState.profile.lastName){
      setValue('fullname',`${globalState.profile.firstName} ${globalState.profile.lastName}`);
      }else if(globalState.profile.firstName){
      setValue('fullname',`${globalState.profile.firstName}`);
      }
      setValue('phonenumber',globalState.profile.phonenumber);
      setValue('photo',globalState.profile.photo);
      setPhoto(globalState.profile.photo);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit,globalState.profile.profileUpdate])
  
  const handleSubmitData = async (data: SubmitData) => { 
    setDisable(true);
    setInputData(data);
    const uniquefilename = `images/${moment().unix()}-${file}`;
    
    if(fileName){
      await getSignerUrlForUpload({
        variables: {
          'bucketName': bucketName,
          'key': uniquefilename}});
    }else{
      const fullName = data?.fullname || '';
      const words = fullName.split(' ');
      const lastname = words.length > 1 ? words.pop():"" ;
      const firstname = words.join(' ')

      await uploadAdminProfile({
        variables: {
          "emailId" : globalState?.profile?.mailId ? globalState?.profile?.mailId : "",
          "input": {
            "u_first_name": firstname,
            "u_last_name": lastname,
            "u_phone_number": data?.phonenumber,
            "u_avatar_url": photo
          }
        }
       })
    }
    
     


    setIsEdit(false);     
    reset();
  }

const handleImageChange = (event: any) => {
  const file = event.target.files[0];
  if (file) {
    const fileType = file?.type;
    const MAX_FILE_SIZE_MB = 5; 
    const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml'];
    const fileSizeInMB = file.size / (1024 * 1024);
    if (!ALLOWED_FILE_TYPES.includes(fileType) || fileSizeInMB >= MAX_FILE_SIZE_MB) {
      error('Please upload an image file (JPG, PNG, JPEG, or SVG) that is less than or equal to 5MB');
      event.target.value = null;
      setFileName(null); 
      setValue('photo', '');
    } else {
      setFileName(file);
      setFile(file.name.replace(/\s+|\(|\)/g, ''))
      setValue('photo', file);
      trigger('photo');
    }
  }
};
  const handleRemovePhoto = () => {
    setFileName(null);
    setValue('photo','');
    const fileId = document.getElementById('fileInput')  as HTMLInputElement | null;
    if(fileId){
        fileId.value = '';
    }
  }

  const formatPhoneNumber = (inputValue:string) => {
    if(inputValue.length === 10){
      const phoneNumber = inputValue.replace(/\D/g, '');
      return phoneNumber.replace(
        /(\d{3})(\d{3})(\d{4})/,
        '($1) $2-$3'
      );
    }
    return inputValue;
  };

  const handlePhoneNumberChange = (value: string) => {
    const inputPhoneNumber = value;
    // Remove non-numeric characters
    const numericPhoneNumber = inputPhoneNumber.replace(/\D/g, '');
    let formattedPhoneNumber : string = '';
    if(numericPhoneNumber.length === 10){
      trigger("phonenumber");
      formattedPhoneNumber = formatPhoneNumber(numericPhoneNumber);
    }else if(numericPhoneNumber.length > 10){
      // const beforeSetValue = numericPhoneNumber.slice(0,10);
      formattedPhoneNumber = formatPhoneNumber(numericPhoneNumber.slice(0,10));
    }else if(numericPhoneNumber.length < 10){
      trigger("phonenumber");
      formattedPhoneNumber = numericPhoneNumber;
    }
    setValue('phonenumber', formattedPhoneNumber);
  };

  const handleCancelEditData = () => {
    setIsEdit(false);
    setFileName(null)
    setValue("photo","")
    setInputData({
      email: "",
      fullname: "",
      phonenumber: "",
      photo : ""
    });
    reset();
  }
  useEffect(() => {
    if((watch("fullname") === `${globalState.profile.firstName} ${globalState.profile.lastName}`) && (watch("phonenumber")===`${globalState.profile.phonenumber}`)){
      setDisable(true);
    }else{
      setDisable(false);
    }
    if(fileName){
      setDisable(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[watch("fullname"),watch("phonenumber"),fileName])

  useEffect(()=>{
    const tempValue = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      tempValue.globalSearch.searchtext = "";
      tempValue.globalSearch.affiliateUsersClicked = false;
      handleGlobalState(tempValue);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {
    handlePhoneNumberChange(watch("phonenumber"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch("phonenumber")]);


  useEffect(() => {
    getUserProfile();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  return (
    <>
      <MyAccountTop isEdit = {isEdit} setIsEdit={setIsEdit}/>
      {
        profileLoading 
      ?
        <div className={styles.profileCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
      :
      <form className={styles.profileDetails} onSubmit={handleSubmit(handleSubmitData)}>
      <div >
        <div className={styles.bg}>
              <div className={isEdit ? styles.imgIcon : styles.beforeImageIcon}>
              {isEdit ? <div  data-testid="clickable-div" className={styles.closeIconStyle} onClick={handleRemovePhoto}><CloseIcon/></div> : ''}
                  <input
                    id='fileInput'
                    type='file'
                    name='photo'
                    data-testid='photo'
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                  />
                  <div className={isEdit ? styles.uploadImage : styles.beforeUploadImage}>
                    <label>
                    <img
                      src={fileName ? URL.createObjectURL(fileName): globalState.profile.photo? (baseURL+globalState.profile.photo):DefaultProfile}
                      alt='Selected'
                      className={styles.imageStyle}
                    />
                    </label>
                  </div>
                  {isEdit ? <label htmlFor='fileInput' className={isEdit ? styles.uploadText : styles.beforeUploadText}>Upload</label> : ''}
              </div>
              <div className={styles.bg1}>
                <img
                  className={styles.personDoodleIcon}
                  alt="backgroundImage"
                  src={personDoodle}
                />
              </div>
              {isEdit
            ? 
            <div className={styles.textFieldsContainer}>
                <div className={styles.textFieldsStyle}>
                  <div className={styles.TextAndNumberTextField}>
                    <span className={styles.fullnameStyle}>
                          <div className={styles.titlePlaceholder}>
                            <div className={styles.email}>Full Name</div>
                          </div>
                          <InputField 
                              variant="outlined"
                              data-testid='fullName'
                              fullWidth
                              {...register("fullname",{
                              required: "Fullname is required!",
                              pattern: {
                                value: /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
                                message: 'Enter valid name'
                              },
                              maxLength: {
                                value: 50,
                                message: 'Fullname should not exceed 20 characters'
                            }
                              })}
                              placeholder={'Enter Fullname'}
                              InputProps={{
                                  style: InputPropsForAddAffiliates,
                              }}
                              onKeyDown={(e) => {
                                const regex = /^[a-zA-Z\s]+$/;
                                if (e && !regex.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              error={Boolean(errors?.fullname?.message)}
                        />
                        <span className={styles.errorMsgStyle}>{errors?.fullname?.message}</span>
                    </span>
                    <span className={styles.numberInputStyle}>
                        <div className={styles.titlePlaceholder}>
                            <div className={styles.email}>Phone Number</div>
                        </div>
                        <InputField 
                              variant="outlined"
                              data-testid='phonenumber'
                              fullWidth
                              {...register("phonenumber",{
                              required: "Phone number is required!",
                              pattern: {
                                value: /^(?=.*[1-9])\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/,
                                message: "Enter valid phone number"
                              },
                              minLength: {
                                value: 10,  
                                message: "Phone number should be 10 characters"
                              }
                              })}
                              placeholder={'Enter PhoneNumber'}
                              InputProps={{
                                  style: InputPropsForAddAffiliates,
                              }}
                              error={Boolean(errors?.phonenumber?.message)}
                        />
                        <span className={styles.errorMsgStyle}>{errors?.phonenumber?.message}</span>
                  </span>
                  </div>
                  <div className={styles.emailFieldStyle}>
                    <span>
                    <div className={styles.titlePlaceholder}>
                        <div className={styles.email}>Email</div>
                    </div>
                    <EmailInputField disabled = {true} errors={errors} register={register} moduleName={'profile'}/>    
                    </span>
                  </div>
                </div>
                <div className={styles.CTAStyles}>
                    <div>
                        <CustomizeButton onClick={() => handleCancelEditData()}> Cancel </CustomizeButton>
                    </div>
                    <div>
                        <CustomizeButton type="submit" classes={{root: disable ? styles.SaveChangesBtnDisable : styles.SaveChangesBtn}} disabled={disable}> Save Changes </CustomizeButton>
                    </div>
                </div>
            </div>
            : <div className={styles.details}>
                <div className={styles.eventDetails}>
                  <div className={styles.event}>
                    <div className={styles.fullName}>Full Name</div>
                    <div className={styles.adminMailId}>
                      {globalState.profile.firstName
                        ? globalState.profile.firstName
                        : ""}
                      &nbsp;
                      {globalState.profile.lastName
                        ? globalState.profile.lastName
                        : ""}
                    </div>
                  </div>
                  <div className={styles.event}>
                    <div className={styles.fullName}>Phone Number</div>
                    <div className={styles.adminMailId}>
                      {globalState.profile.phonenumber
                      ? globalState.profile.phonenumber
                      : '-'}
                    </div>
                  </div>
                  <div className={styles.event}>
                    <div className={styles.fullName}>Email</div>
                    <div className={styles.adminMailId}>
                      {globalState?.profile?.mailId
                        ? globalState?.profile?.mailId
                        : "-"}
                    </div>
                  </div>
                </div>
              </div>
              } 
        </div>
      </div>
      </form>
     }
    </>
  );
};

export default ProfileDetails;
